import React, { useEffect, useState } from "react";
import {
  AESEncryption,
  ApiResDecrypt,
  truncate,
} from "../../../CommonMethhods/CommonMethods";
import { Constants } from "../../../CommonMethhods/Constants";
import { numDifferentiation } from "../../../CommonMethhods/CovertRupees";
import { DASHBOARD_CLIENT_OVERVIEW } from "../../../Configuration/API_URL";
import SmallLoader from "../../Common/smallLoader";
import axiosInstance from "../../../CommonMethhods/axiosInstance";

function SummaryClientDetail() {
  const storeToken = localStorage.getItem("ssoToken");
  const [summaryData, setSummaryData] = useState();
  const [loader, setLoader] = useState(true);
  let clientCode = "";

  const getSummaryClient = async (clientCode) => {
    let payloadValue = { ClientCode: clientCode };
    let encPayload = AESEncryption(payloadValue);
    try {
      const clientSummaryData = await axiosInstance.post(
        DASHBOARD_CLIENT_OVERVIEW.SummaryClient_URL,

        `"${encPayload}"`,
      );
      const resp = ApiResDecrypt(clientSummaryData?.data);
      setSummaryData(resp?.data);
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };
  useEffect(() => {
    if (localStorage.getItem("clientCode")) {
      clientCode = localStorage.getItem("clientCode");
      getSummaryClient(clientCode);
    }
  }, []);

  const AvlTrad =
    summaryData === undefined || null
      ? "NA"
      : summaryData.availableTradng === undefined || null
      ? "NA"
      : numDifferentiation(summaryData.availableTradng);

  const LedgerBal =
    summaryData === undefined || null
      ? "NA"
      : summaryData.LedegerBal === undefined || null
      ? "NA"
      : numDifferentiation(summaryData.LedegerBal);

  const MarAgainstAssets =
    summaryData === undefined || null
      ? "NA"
      : summaryData.Margin_against_Assests === undefined || null
      ? "NA"
      : numDifferentiation(summaryData.Margin_against_Assests);

  return (
    <div className="card-box summary-client bottom-25">
      <div className="card-title">
        <div className="figure-inlac">
          <h2>{Constants.Summary_Client}</h2>
          {/* <p>{Constants.Figure_In_Lacs_for_all}</p> */}
        </div>
      </div>
      {/* {loader ? (
        <div className="loader-alignment">
          <Loader />
        </div>
      ) : (
        <> */}
      {/* {summaryData == undefined || summaryData.length <= 0 ? (
            noDataFound()
          ) : (
            <> */}

      <div className="card-content-summary row">
        <div className="left-side-summary col-md-3 col-sm-12">
          <ul className="summary-ul background-grey1">
            <li>
              <p className="summary-small-title">
                {Constants.Available_For_Trading}
              </p>

              <p
                className={` ${
                  parseInt(AvlTrad) < 0 ? "red-txt" : "green-txt"
                }`}
              >
                {loader ? <SmallLoader /> : <>{AvlTrad}</>}
              </p>
            </li>

            <li>
              <p className="summary-small-title">
                {Constants.Future_Bill_Cr_Dr}
              </p>
              <p className="summary-small-value">
                {loader ? (
                  <SmallLoader />
                ) : (
                  <>
                    <i>₹ </i>

                    {summaryData === undefined || null
                      ? "NA"
                      : summaryData.Futurebill === undefined || null
                      ? "NA"
                      : numDifferentiation(summaryData.Futurebill)}
                  </>
                )}
              </p>
            </li>
            <li>
              <p className="summary-small-title">{Constants.Margin_Utilised}</p>
              <p className="summary-small-value">
                {loader ? (
                  <SmallLoader />
                ) : (
                  <>
                    <i>₹ </i>

                    {summaryData === undefined || null
                      ? "NA"
                      : summaryData.MarginUtilised === undefined || null
                      ? "NA"
                      : numDifferentiation(summaryData.MarginUtilised)}
                  </>
                )}
              </p>
            </li>
          </ul>
        </div>
        <div className="right-side-summary col-md-9 col-sm-12">
          <div className="right-row-content row background-grey2">
            <p className="summary-small-title ">{Constants.Ledger_Balalnce}</p>
            {/* <i>₹ </i> */}
            <p
              className={`${parseInt(LedgerBal) < 0 ? "red-txt" : "green-txt"}`}
            >
              {loader ? <SmallLoader /> : <>{LedgerBal}</>}
            </p>
          </div>
          <ul className="summary-right-ul row">
            <li>
              <p className="summary-right-small-title">
                {Constants.Today_Balance}
              </p>
              <p className="summary-right-small-value">
                {loader ? (
                  <SmallLoader />
                ) : (
                  <>
                    <i>₹ </i>

                    {summaryData === undefined || null
                      ? "NA"
                      : summaryData.LEDBAL_Today === undefined || null
                      ? "NA"
                      : numDifferentiation(summaryData.LEDBAL_Today)}
                  </>
                )}
              </p>
            </li>

            <li>
              <p className="summary-right-small-title">
                {Constants.Today_Pay_in}
              </p>
              <p className="summary-right-small-value">
                {loader ? (
                  <SmallLoader />
                ) : (
                  <>
                    <i>₹ </i>

                    {summaryData === undefined || null
                      ? "NA"
                      : summaryData.payin === undefined || null
                      ? "NA"
                      : numDifferentiation(summaryData.payin)}
                  </>
                )}
              </p>
            </li>
            <li>
              <p className="summary-right-small-title">
                {Constants.Today_Payout}
              </p>
              <p className="summary-right-small-value">
                {loader ? (
                  <SmallLoader />
                ) : (
                  <>
                    <i>₹ </i>

                    {summaryData === undefined || null
                      ? "NA"
                      : summaryData.payout === undefined || null
                      ? "NA"
                      : numDifferentiation(summaryData.payout)}
                  </>
                )}
              </p>
            </li>
            <li>
              <p className="summary-right-small-title">{Constants.Charges}</p>
              <p className="summary-right-small-value">
                {loader ? (
                  <SmallLoader />
                ) : (
                  <>
                    <i>₹ </i>

                    {summaryData === undefined || null
                      ? "NA"
                      : summaryData.MTF === undefined || null
                      ? "NA"
                      : numDifferentiation(summaryData.MTF)}
                  </>
                )}
              </p>
            </li>
            <li>
              <p className="summary-right-small-title tooltip123">
                {truncate("DPC")}
                <span className="tooltiptext">
                  {Constants.Delayed_Payment_Charges}
                </span>

                {/* */}
              </p>
              <p className="summary-right-small-value">
                {loader ? (
                  <SmallLoader />
                ) : (
                  <>
                    <i>₹ </i>

                    {summaryData === undefined || null
                      ? "NA"
                      : summaryData.DPC === undefined || null
                      ? "NA"
                      : numDifferentiation(summaryData.DPC)}
                  </>
                )}
              </p>
            </li>
            <li>
              <p className="summary-right-small-title">
                {Constants.DP_Charges}
              </p>
              <p className="summary-right-small-value">
                {loader ? (
                  <SmallLoader />
                ) : (
                  <>
                    <i>₹ </i>

                    {summaryData === undefined || null
                      ? "NA"
                      : summaryData.DP === undefined || null
                      ? "NA"
                      : numDifferentiation(summaryData.DP)}
                  </>
                )}
              </p>
            </li>
          </ul>

          <div className="right-row-content row background-grey2">
            <p className="summary-small-title ">
              {Constants.Margin_Against_Assets}
            </p>

            <p className={`${MarAgainstAssets < 0 ? "red-txt" : "green-txt"}`}>
              {loader ? <SmallLoader /> : <>{MarAgainstAssets}</>}
            </p>
          </div>
          <ul className="summary-right-ul row">
            <li>
              <p className="summary-right-small-title">
                {Constants.Early_Payin}
              </p>
              <p className="summary-right-small-value">
                {loader ? (
                  <SmallLoader />
                ) : (
                  <>
                    <i>₹ </i>

                    {summaryData === undefined || null
                      ? "NA"
                      : summaryData.Early_Payin === undefined || null
                      ? "NA"
                      : numDifferentiation(summaryData.Early_Payin)}
                  </>
                )}
              </p>
            </li>
            <li>
              <p className="summary-right-small-title">
                {Constants.Margin_Against_Holdings}
              </p>
              <p className="summary-right-small-value">
                {loader ? (
                  <SmallLoader />
                ) : (
                  <>
                    <i>₹ </i>

                    {summaryData === undefined || null
                      ? "NA"
                      : summaryData.Margin_against_Holding === undefined || null
                      ? "NA"
                      : numDifferentiation(summaryData.Margin_against_Holding)}
                  </>
                )}
              </p>
            </li>
            <li>
              <p className="summary-right-small-title">{Constants.Cfs}</p>
              <p className="summary-right-small-value">
                {loader ? (
                  <SmallLoader />
                ) : (
                  <>
                    <i>₹ </i>

                    {summaryData === undefined || null
                      ? "NA"
                      : summaryData.CFS === undefined || null
                      ? "NA"
                      : numDifferentiation(summaryData.CFS)}
                  </>
                )}
              </p>
            </li>
          </ul>
        </div>
      </div>
      <div className="mtf-row-wrapper">
        {/* <div className="mtf-data"> */}
          <div className="right-row-content row background-grey2">
            <p className="summary-small-title">{Constants.Mtf_pa}</p>
            <p className="mb-0">
              {loader ? (
                <SmallLoader />
              ) : (
                <>
                  {summaryData === undefined || null
                    ? "NA"
                    : summaryData.MTF_INT === undefined || null
                    ? "NA"
                    : numDifferentiation(summaryData.MTF_INT) + "%"}
                </>
              )}
            </p>
          </div>
        {/* </div> */}

        <div className="right-row-content row background-grey2">
          <p className="summary-small-title mb-0">{Constants.DPC_pa}</p>
          <p className="mb-0">
            {loader ? (
              <SmallLoader />
            ) : (
              <>
                {summaryData === undefined || null
                  ? "NA"
                  : summaryData.DPC_INT === undefined || null
                  ? "NA"
                  : numDifferentiation(summaryData.DPC_INT) + "%"}
              </>
            )}
          </p>
        </div>
      </div>
    </div>
  );
}

export default SummaryClientDetail;
